'use strict';
const deepAssign = require('../deep-assign'),
	colorParser = require('./color-parser'),
	isObjectObject = require('@mindmup/js-utils/src/is-object-object'),
	attributeForPath = function (object, pathArray, fallback) {
		if (!object || !pathArray || !pathArray.length) {
			return (object === undefined && fallback) || object;
		}
		if (pathArray.length === 1) {
			return (object[pathArray[0]] === undefined && fallback) || object[pathArray[0]];
		}
		let remaining = pathArray.slice(0),
			current = object;

		while (remaining.length > 0) {
			current = current[remaining[0]];
			if (current === undefined) {
				return fallback;
			}
			remaining = remaining.slice(1);
		}
		return current;
	},
	themeAttributeValue = (themeDictionary, prefixes, styles, postfixes, fallback) => {
		const rootElement = attributeForPath(themeDictionary, prefixes);
		let toAssign = [{}];
		if (!rootElement) {
			return fallback;
		}
		if (styles && styles.length) {
			toAssign = toAssign.concat(styles.slice(0).reverse().map(style => rootElement[style]).filter(item => !!item));
		} else if (isObjectObject(rootElement)) {
			toAssign.push(rootElement);
		} else if (!postfixes || !postfixes.length) {
			return rootElement;
		} else {
			return fallback;
		}
		return attributeForPath(deepAssign.apply(deepAssign, toAssign), postfixes, fallback);
	},
	nodeAttributeToNodeTheme = (nodeAttribute) => {
		const getBackgroundColor = function () {
				const colorObj = attributeForPath(nodeAttribute, ['background']);
				if (colorObj) {
					return colorParser(colorObj);
				}
				return attributeForPath(nodeAttribute, ['backgroundColor']);
			},
			result = {},
			isUnlabelled = nodeAttribute && attributeForPath(nodeAttribute, ['unlabelled']),
			editingContext = nodeAttribute && attributeForPath(nodeAttribute, ['nodeEditingContext']);
		if (nodeAttribute) {
			result.margin = attributeForPath(nodeAttribute, ['text', 'margin']);
			result.font = attributeForPath(nodeAttribute, ['text', 'font']);
			result.text = attributeForPath(nodeAttribute, ['text']);
			result.borderType = attributeForPath(nodeAttribute, ['border', 'type']);
			result.backgroundColor = getBackgroundColor();
			result.cornerRadius = attributeForPath(nodeAttribute, ['cornerRadius']);
			result.lineColor = attributeForPath(nodeAttribute, ['border', 'line', 'color']);
			result.lineWidth = attributeForPath(nodeAttribute, ['border', 'line', 'width']);
			result.lineStyle = attributeForPath(nodeAttribute, ['border', 'line', 'style']);
			result.decorations =  attributeForPath(nodeAttribute, ['decorations']);
			if (editingContext) {
				result.nodeEditingContext = editingContext;
			}
			if (isUnlabelled) {
				result.unlabelled = attributeForPath(nodeAttribute, ['unlabelled']);
			}
		}
		return result;

	},
	connectorControlPoint = (themeDictionary, childPosition, connectorStyle, connectorArrows) => {
		const controlPointPostFixFull = connectorArrows ? `-arrow-${connectorArrows}` : '',
			controlPointPostFixPart = connectorArrows ? '-arrow' : '',
			configuredControlPoint1 = connectorStyle && attributeForPath(themeDictionary, ['connector', connectorStyle, `controlPoint${controlPointPostFixFull}`, childPosition]),
			configuredControlPoint2 = !configuredControlPoint1 && connectorStyle && attributeForPath(themeDictionary, ['connector', connectorStyle, `controlPoint${controlPointPostFixPart}`, childPosition]),
			fallbackControlPoint = !(configuredControlPoint1 || configuredControlPoint2) && connectorStyle && attributeForPath(themeDictionary, ['connector', connectorStyle, 'controlPoint', childPosition]),
			defaultConnector = !(configuredControlPoint1 || configuredControlPoint2 || fallbackControlPoint) && themeDictionary.connector[themeDictionary.node.default.connections.style],
			defaultControlPoint = defaultConnector && (childPosition === 'horizontal' ? defaultConnector.controlPoint.horizontal : defaultConnector.controlPoint.above),
			returnedControlPoint = configuredControlPoint1 || configuredControlPoint1 || fallbackControlPoint || defaultControlPoint;

		return Object.assign({}, returnedControlPoint);
	};

module.exports = {
	attributeForPath: attributeForPath,
	themeAttributeValue: themeAttributeValue,
	nodeAttributeToNodeTheme: nodeAttributeToNodeTheme,
	connectorControlPoint: connectorControlPoint
};
